import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react'
import Form from '../../Aplicacao/form'
import Select from '../../../../components/Select'
import auth from '../../../../utils/auth'
import cfg from '../../../../utils/config'
import axios from 'axios'
import { LnsCadastroRapidoContext } from '../../../../contexts/LnsCadastroRapido'
import helper from '../../../../utils/helper'
import ReactLoading from "react-loading"

const Aplicacoes = forwardRef((props, ref) => {
    const userInfo = auth.getUserInfo()
    const formRef = useRef()

    const { setApplicationId, applicationId, setSelectedApplicationType, selectedApplicationType } = useContext(LnsCadastroRapidoContext)

    const [applicationType, setApplicationType] = useState(null)
    const [selectedApplication, setSelectedApplication] = useState(null)
    const [applicationOptions, setApplicationOptions] = useState([])
    const [loadingApplications, setLoadingApplications] = useState(false)

    const hasApplications = applicationOptions.length

    const applicationTypeOptions = [
        { label: 'Nova Aplicação', value: 'newApplication' },
        { label: 'Usar Aplicação Existente', value: 'selectApplication' }
    ]

    useEffect(() => {
        getAplicacoes()
    }, [])

    useEffect(() => {
        if (loadingApplications) return

        if (applicationId && selectedApplicationType) {
            setApplicationType(selectedApplicationType)

            if (selectedApplicationType === 'selectApplication') {
                setSelectedApplication(applicationId)
            }

            return
        }

        if (!hasApplications) {
            setApplicationType('newApplication')
            setSelectedApplicationType('newApplication')

            return
        }

        setApplicationType(null)

    }, [loadingApplications, hasApplications, applicationId, selectedApplicationType])

    useImperativeHandle(ref, () => ({
        onNext: async () => {
            if (applicationType === 'newApplication') {
                const result = await formRef.current?.handleQuickRegister()

                if (!result?.success) {
                    return false
                }

                setApplicationId(result.applicationId)
                setSelectedApplicationType('newApplication')

                return true
            }

            if (applicationType === 'selectApplication') {
                if (!selectedApplication) {
                    const span = document.getElementById('validacao-aplicacao')
                    if (span) {
                        span.innerHTML = 'Selecione uma aplicação.'
                    }

                    return false
                }

                setApplicationId(selectedApplication)
                setSelectedApplicationType('selectApplication')
                const result = await new Promise((resolve) => {
                    helper.dispatchEvent("showAviso", {
                        message: "Aplicação selecionada com sucesso.",
                        callback: () => resolve(true),
                        callbackClose: () => resolve(true)
                    })
                })

                return result
            }

            const span = document.getElementById('validacao-tipo-aplicacao')
            if (span) {
                span.innerHTML = 'Selecione o tipo de aplicação.'
            }

            return false
        }
    }))

    const getAplicacoes = async (clienteId = false) => {
        try {
            setLoadingApplications(true)

            let requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/application/`

            if (clienteId) {
                requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/application/?cliente=${clienteId}`
            }

            const configMe = {
                headers: {
                    Authorization: `Bearer ${auth.getToken()}`
                }
            }

            const { data } = await axios.get(requestURL, configMe)

            const optionsAplicacao = data.results.map((item) => ({
                label: item.name,
                value: item.id
            }))

            setApplicationOptions(optionsAplicacao)
        } catch (error) {
            console.error('Erro ao buscar aplicações:', error)
            setApplicationOptions([])
        } finally {
            setLoadingApplications(false)
        }
    }

    const handleApplicationTypeChange = (option) => {
        setApplicationType(option.value)

        const spanTipo = document.getElementById('validacao-tipo-aplicacao')
        if (spanTipo) spanTipo.innerHTML = ''

        if (option?.value !== 'selectApplication') {
            setSelectedApplication(null)
        }
    }

    const handleSelectApplication = (option) => {
        setSelectedApplication(option.value)

        const spanAplicacao = document.getElementById('validacao-aplicacao')
        if (spanAplicacao) spanAplicacao.innerHTML = ''
    }

    return (
        <div className="hdv-form-default">
            <div className="hdv-default-header mx-3">
                <span className="screen-menu-desc">
                    <i
                        className="fa fa-info-circle fa-20px"
                        title='Informações do Cadastro de Aplicações'
                        style={{
                            cursor: "pointer",
                            marginRight: '5px',
                            marginTop: '10px',
                        }}
                        onClick={() =>
                            helper.dispatchEvent("showAviso", {
                                message:
                                    `As Aplicações representam um agrupamento de dispositivos relacionados.
                                    Use para organizar seus dispositivos por projeto, localidade ou cliente.`,
                            })
                        }
                    />

                    {applicationId ? <h4>Editar Aplicação</h4> : <h4>Nova Aplicação</h4>}

                    <div className="gray-background">
                        <i className="las la-project-diagram la-2x"></i>
                    </div>
                </span>
            </div>

            {loadingApplications ? (
                <div className="loading-screen-overlay">
                    <ReactLoading
                        type="spin"
                        color="var(--background-menu)"
                        width={40}
                    />
                </div>
            ) : (
                <>
                    {!!hasApplications && (
                        <div className="row">
                            <div className="col-md-6">
                                <label className="required">
                                    Tipo de Aplicação
                                </label>
                                <Select
                                    options={applicationTypeOptions}
                                    value={applicationType}
                                    onChange={handleApplicationTypeChange}
                                    resolveValueFromOptions
                                    disabled={!hasApplications || applicationId}
                                />
                                <span id="validacao-tipo-aplicacao"></span>
                            </div>

                            {applicationType === 'selectApplication' && (
                                <div className="col-md-6">
                                    <label className="required">Aplicação</label>
                                    <Select
                                        options={applicationOptions}
                                        value={selectedApplication}
                                        onChange={handleSelectApplication}
                                        resolveValueFromOptions
                                        disabled={loadingApplications || applicationId}
                                    />
                                    <span id="validacao-aplicacao"></span>
                                </div>
                            )}
                        </div>
                    )}

                    {applicationType === 'newApplication' && (
                        <>
                            {!!hasApplications && <hr />}

                            <Form
                                ref={formRef}
                                isQuickRegister
                                applicationId={applicationId}
                            />
                        </>
                    )}
                </>
            )}
        </div>
    )
})

export default Aplicacoes
